export enum PublishedStatus {
    PUBLISHED = 'published',
    REVIEW = 'review',
    DRAFT = 'draft',
}
